const FeaturedProject = ({ title, description, tech, link, lightMode }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        group
        w-[260px] sm:w-[300px] md:w-[320px]
        px-3 sm:px-4 py-3 sm:py-4
        border-b border-t transition-all duration-300
        ${
          lightMode ?
            "border-gray-300 hover:bg-gray-100"
          : "border-gray-700 hover:bg-white/5"
        }
      `}>
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3
          className={`
            text-[10px] sm:text-xs md:text-sm
            uppercase tracking-widest
            font-terminal font-semibold
            ${lightMode ? "text-gray-600" : "text-gray-400"}
          `}>
          {title}
        </h3>

        <span className="text-xs opacity-60 group-hover:translate-x-1 transition">
          →
        </span>
      </div>

      {/* Description */}
      <p
        className={`
          text-[10px] sm:text-xs
          mt-2 font-terminal leading-relaxed
          ${lightMode ? "text-gray-600" : "text-gray-400"}
        `}>
        {description}
      </p>

      {/* Tech Stack */}
      <div
        className={`
          flex flex-wrap justify-between
          gap-1 sm:gap-2 mt-3
          text-[9px] sm:text-[10px]
          font-terminal
          text-gray-500
        `}>
        {tech.map((item, index) => (
          <span key={index}>{item}</span>
        ))}
      </div>
    </a>
  );
};

export default FeaturedProject;
